<template>
<div>
	<!-- Dialog -->
	<v-dialog v-model="showDialog" max-width="400">
		<v-card>
			<v-card-title class="headline">
				Contact Us
			</v-card-title>
			<v-card-text class="pb-2">
				Contact us to inquire about the department.
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" text @click="showDialog = false">
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-row class="d-flex justify-space-between align-center">
		<v-col cols="12" >
			<!-- tabs -->
			<v-tabs v-model="tab" show-arrows height="35" centered grow @change="handleTabChange(tab)">
				<v-tab
					class="text-capitalize "
					:class="{'border-style': !showManager}"
				>
					<div v-if="!showManager" class="premier-icon d-flex align-center flex-column">
						<v-icon class="" size="18" color="#fb5d33">mdi-crown</v-icon>
						<span class="text-style">Premier</span>
					</div>
					Manager
				</v-tab>

				<v-tab
					class="text-capitalize "
					:class="{'border-style': !showCp}"
				>
					<div v-if="!showCp" class="premier-icon d-flex align-center flex-column">
						<v-icon class="" size="18" color="#fb5d33">mdi-crown</v-icon>
						<span class="text-style">Premier</span>
					</div>
					Message Cp
				</v-tab>

				<v-tab
					class="text-capitalize premier-tab"
					:class="{'border-style': !showTransport}"
				>
					<div v-if="!showTransport" class="premier-icon d-flex align-center flex-column">
						<v-icon class="" size="18" color="#fb5d33">mdi-crown</v-icon>
						<span class="text-style">Premier</span>
					</div>
					Transport
				</v-tab>

				<v-tabs-slider color="primary"></v-tabs-slider>
			</v-tabs>
			<v-divider class="mb-2"/>
			<v-tabs-items v-model="tab" >
				<v-tab-item v-if="showManager">
					<iframe :src="managerUrl" style="width: 100%; height: 85vh; border: none;" title="Manager"></iframe>
				</v-tab-item>
				<v-tab-item  v-if="showCp">
					<iframe :src="cpUrl" style="width: 100%; height: 85vh; border: none;" title="Manager"></iframe>
				</v-tab-item>
				<v-tab-item v-if="showTransport">
					<iframe :src="transportUrl" style="width: 100%; height: 85vh; border: none;" title="Manager"></iframe>
				</v-tab-item>
			</v-tabs-items>
		</v-col>
	</v-row>

	<!-- child page -->
	<loader v-if="loading"/>
</div>
</template>
<script>
export default {
	data () {
		return {
			tab: 0,
			loading: false,
			managerUrl: 'https://manager.mirror.edunixsystem.com',
			cpUrl: 'https://cp.mirror.edunixsystem.com',
			transportUrl: 'https://transport-ui.mirror.edunixsystem.com',

			showCp: true,
			showTransport: true,
			showManager: true,
			showDialog: false
		}
	},

	methods: {
		handleTabChange (newTab) {
			// إذا كان التبويب الثاني (Cp) وقيمة showCp هي false
			if (newTab === 1 && !this.showCp) {
				this.showDialog = true // إظهار الـ dialog
				this.tab = this.previousTab // العودة إلى التبويب السابق
				return
			} else if (newTab === 0 && !this.showManager) {
				this.showDialog = true // إظهار الـ dialog
				// this.tab = this.previousTab // العودة إلى التبويب السابق
			} else if (newTab === 0 && !this.showTransport) {
				this.showDialog = true // إظهار الـ dialog
				this.tab = this.previousTab
			}
			this.previousTab = newTab
		}
	}
}
</script>

<style scoped>
.border-style {
	border: 2px solid #fb5d33;
	border-radius: 10px ;
}

.premier-tab {
	position: relative;
	overflow: visible !important;
}

.premier-icon {
	position: absolute;
	top: 0px;
	right: 2%;
	color: gold;
}

.text-style {
	color: #fb5d33;
	font-size: 10px;
}
</style>
